export default {
  'pages.team.title': 'Company',
  'pages.team.createForm.newTeam': 'New company',
  'pages.team.createForm.teamName': 'Company name',
  'pages.team.createForm.teamName.required': 'Company name is required',
  'pages.team.createForm.teamDescription' : 'Company description',

  'pages.account.setting' : 'Account Settings',
  'pages.account.basesettings': 'Basic Settings',
  'pages.account.security': 'Security Settings',
  'pages.account.rule.companyRequired': 'Please contact the administrator to get company information!',
  'pages.account.rule.emailRequired': 'Please contact the administrator to get email information!',

  //-- 报表API授权管理
  'pages.reportApi.menuMap.OB': 'OpenBrowser API',
  'pages.reportApi.menuMap.MP': 'MetaXTV API',
  'pages.reportApi.menuMap.AdSdk': 'AdSDK API',
  'pages.reportApi.menuMap.DistributionOwn': 'MetaX Platform API',
  'pages.reportApi.menuMap.DistributionThirdParty': 'Third Party Platform API',
  'pages.reportApi.applyToken.title': 'API Authorization',
  'pages.reportApi.applyToken.description': 'Click the button to apply for API token authorization.',
  'pages.reportApi.applyToken.button': 'Apply Token',

  'pages.account.password': 'Account Password',
  'pages.account.currently.email': 'Currently bound email',
  'pages.account.modifyPassword': 'Modify Password',
  'pages.account.modifyPassword.confirm': 'Are you sure to modify the password?',
  
  'pages.access.resendEmailVerification' : 'Resend Email Verification',
  'pages.access.sendEmailVerificationCheck': 'Send Email Verification Notification?',
  'pages.access.deleteUserCheck': 'Delete this user?',
  'pages.access.createForm.newUser': 'New User',
  'pages.access.createForm.userName': 'User name',
  'pages.access.createForm.userName.required': 'User name is required',
  'pages.access.createForm.userEmail': 'User email',
  'pages.access.createForm.userEmail.required': 'User email is required',
};
